var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 20,
    fill: "#FFDAC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5562_163484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1049 33.7188H34.5013C33.4281 33.72 32.3992 34.147 31.6403 34.9059C30.8813 35.6648 30.4544 36.6937 30.4531 37.767V41.8854H45.1531V37.767C45.1518 36.6937 44.7249 35.6648 43.966 34.9059C43.2071 34.147 42.1782 33.72 41.1049 33.7188V33.7188Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8023 32.0852C40.5085 32.0852 42.7023 29.8914 42.7023 27.1852C42.7023 24.479 40.5085 22.2852 37.8023 22.2852C35.0961 22.2852 32.9023 24.479 32.9023 27.1852C32.9023 29.8914 35.0961 32.0852 37.8023 32.0852Z",
    fill: "#FE9452"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5562_163484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3358 29.9062L17.3349 29.9063C15.6606 29.9083 14.0554 30.5743 12.8715 31.7582C11.6876 32.9421 11.0216 34.5473 11.0195 36.2216V36.2225V41.8854V42.6354H11.7695H31.982H32.732V41.8854V36.2225L32.732 36.2216C32.73 34.5473 32.064 32.9421 30.8801 31.7582C29.6961 30.5743 28.091 29.9083 26.4166 29.9063L26.4157 30.6559V29.9062L17.3358 29.9062Z",
    fill: "#FD6202",
    stroke: "#FFDAC4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1156 21.6711C28.1156 25.116 25.323 27.9086 21.8781 27.9086C18.4332 27.9086 15.6406 25.116 15.6406 21.6711C15.6406 18.2262 18.4332 15.4336 21.8781 15.4336C25.323 15.4336 28.1156 18.2262 28.1156 21.6711Z",
    fill: "#FE9452",
    stroke: "#FFDAC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5562_163484"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.0039,
    y: 22.2852,
    width: 19.6,
    height: 19.6,
    rx: 9.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5562_163484"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.40234,
    y: 14.9336,
    width: 26.95,
    height: 26.95,
    rx: 13.475,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCustomers);
export default __webpack_public_path__ + "static/media/totalCustomers.a1ae581a2f5bf64f583412a6d39ba001.svg";
export { ForwardRef as ReactComponent };